import CustomRadio from 'designer/component/element/Radio'
import ControlWrapper from './ControlWrapper'

const RadioControl = (props) => {
  return <ControlWrapper {...props} Component={CustomRadio} />
}

export default RadioControl
